// =============================================
// COMPONENTE: REPORT NODE
// =============================================
// Arquivo: ReportNode.tsx
// Descrição: Nó para geração de relatórios
// =============================================

import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { FileText } from 'lucide-react';
import ActionsBadge from './ActionsBadge';

const ReportNode: React.FC<NodeProps> = ({ data, selected }) => {
  const { label, reportType, format, period, description, actions } = data;

  const getTypeLabel = (t: string) => {
    const labels: Record<string, string> = {
      checklists: 'Checklists',
      vehicles: 'Veículos',
      drivers: 'Motoristas',
      custom: 'Customizado'
    };
    return labels[t] || t;
  };

  const getFormatLabel = (f: string) => {
    const labels: Record<string, string> = {
      pdf: 'PDF',
      xlsx: 'Excel',
      csv: 'CSV'
    };
    return labels[f] || f;
  };

  const getPeriodLabel = (p: string) => {
    const labels: Record<string, string> = {
      today: 'Hoje',
      week: 'Semana',
      month: 'Mês',
      custom: 'Customizado'
    };
    return labels[p] || p;
  };

  return (
    <div className={`flow-node report-node ${selected ? 'selected' : ''}`}>
      <Handle type="target" position={Position.Top} className="flow-handle" />

      <div className="node-header report-header">
        <FileText className="node-icon" size={18} />
        <span className="node-title">{label || 'Relatório'}</span>
      </div>

      <div className="node-body">
        {reportType && (
          <div className="node-field">
            <span className="field-label">Tipo:</span>
            <span className="field-value">{getTypeLabel(reportType)}</span>
          </div>
        )}
        {format && (
          <div className="node-field">
            <span className="field-label">Formato:</span>
            <span className="field-value">{getFormatLabel(format)}</span>
          </div>
        )}
        {period && (
          <div className="node-field">
            <span className="field-label">Período:</span>
            <span className="field-value">{getPeriodLabel(period)}</span>
          </div>
        )}
        {description && (
          <div className="node-description">{description}</div>
        )}
        <ActionsBadge actions={actions} />
      </div>

      <Handle type="source" position={Position.Bottom} className="flow-handle" />
    </div>
  );
};

export default ReportNode;
